import { z } from 'zod';

import { lineageContentSchema } from './lineageContent.js';
import { tagsSchema } from './tags.js';

export const viewSchema = z.object({
  id: z.string(),
  name: z.string(),
  contentUrl: z.string(),
  viewUrlName: z.string().optional(),
  webUrl: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  workbook: z
    .object({
      id: z.string(),
      name: z.string().optional(),
    })
    .optional(),
  owner: z
    .object({
      id: z.string().optional(),
      name: z.string().optional(),
    })
    .optional(),
  project: z
    .object({
      id: z.string().optional(),
      name: z.string().optional(),
    })
    .optional(),
  tags: tagsSchema,
  upstreamDatasources: z.array(lineageContentSchema).optional(),
  totalViewCount: z.number().optional(),
  usage: z
    .object({
      totalViewCount: z.coerce.number(),
    })
    .optional(),
});

export type View = z.infer<typeof viewSchema>;
